import React, { useEffect } from 'react';
import { useQuery } from 'react-query';
import '@ant-design/compatible/assets/index.css';
import { Row, Form, Spin, Divider } from 'antd';

import DF from 'DisplayFramework';
import { FormInstance } from 'antd/lib/form';
import ParListSelect from 'components/ParListSelect';
import { getFinContractViewByTpidandDate } from 'services/fincontract';
import DataGrid from 'components/DataGrid';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import FormInput from 'components/FormInput';
import { toCurrency } from 'utils/utils';
import TextArea from 'antd/lib/input/TextArea';

export type tabColDecisionProps = {
  objectid?: number;
  form?: FormInstance;
  tpid?: number;
  setSuccessful?: any;
};

const TabColDecision = ({ objectid, form, tpid,setSuccessful }: tabColDecisionProps) => {
  const { data, isFetching } = useQuery(
    ['getFinContractViewByTpidandDate', { tpid: tpid }],
    () =>
      getFinContractViewByTpidandDate({ tpid: tpid!, evalDate: '' }).then(
        (res) => res.list || []
      ),
    { refetchOnMount: true, staleTime: 60 * 1000 }
  );

      
  useEffect(() => {
    setSuccessful(isFetching);
  }, [isFetching]);

  
  const columns: DataGridColDef<any>[] = [
    {
      comcode: 'ctreference',
      dataIndex: 'ctreference',
      width: 80,
    },
    {
      comcode: 'ctdescription',
      dataIndex: 'ctdescription',
      width: 100,
    },
    {
      comcode: 'prcode',
      dataIndex: 'prcode',
      width: 60,
    },
    {
      comcode: 'ctstatuslabel',
      dataIndex: 'ctstatus',
      width: 60,
    },
    {
      comcode: 'ctremainingduration',
      dataIndex: 'ctremainingduration',
      width: 80,
    },
    {
      comcode: 'totaloutstandingamount',
      dataIndex: 'totaloutstandingamount',
      render: (val, record) =>
        toCurrency(val, record.elements[0].currcode ?? localStorage.getItem('currcode') ?? ''),
      width: 100,
    },
    {
      comcode: 'totalunpaidamount',
      dataIndex: 'totalunpaidamount',
      render: (val, record) =>
        toCurrency(val, record.elements[0].currcode ?? localStorage.getItem('currcode') ?? ''),
      width: 100,
    },
  ];

  return (
    <DF.Provider pagcode="tabcoldecision">
      <Spin spinning={isFetching}>
        <Row>
          <FormInput col xs={6} name="decision" rules={[{ required: true }]}>
            <ParListSelect parcode="CTSTATUS" parvalueparent="RECOV" />
          </FormInput>
        </Row>
        
          <Form.Item
            name="listcontract"
            rules={[{ required: true, message: 'please select contract !' }]}
          ></Form.Item>
          <DataGrid
            titleComcode='listOfContracts'
            size="small"
            scroll={{ x: 1000, y: 400 }}
            pagination={{ pageSize: 10 }}
            rowSelection={{
              type: 'checkbox',
              onChange: (selectedRowKeys: any, selectedRows: any) => {
                form?.setFieldsValue({
                  listcontract: selectedRowKeys,
                });
              },
            }}
            dataSource={data}
            columns={columns}
            rowKey={(record) => record.ctrid}
          />
           <Divider orientation="left"></Divider>
            <Row gutter={[8, 8]}>
              <FormInput
                col
                xs={18}
                name="comment"
                rules={[{ required: true }]}
              >
                <TextArea rows={6} />
              </FormInput>
            </Row>
        
      </Spin>
    </DF.Provider>
  );
};
export default TabColDecision;
